import { useThemeDetector } from '@upstox/upstox-ui';
import { useStore } from 'modules/Stores';

export default function useCurrentTheme() {
  const { theme } = useStore('AppStore');
  const autoTheme = useThemeDetector();
  const currentTheme = theme === 'auto' ? autoTheme : theme;

  return currentTheme;
}
